import { AnalyticsBrowser } from '@segment/analytics-next';

function getConsentPreferences() {
  const match = document.cookie.match(/tracking-preferences=([^;]+)/);
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

function hasAnalyticsConsent() {
  const prefs = getConsentPreferences();
  // If no preferences yet, default to true (matches initialPreferences behavior)
  if (!prefs) return true;
  return prefs?.custom?.Analytics === true;
}

const writeKey = document.querySelector('meta[name="segment-write-key"]')?.content;

if (writeKey && hasAnalyticsConsent()) {
  window.analytics = AnalyticsBrowser.load({ writeKey });
}
